import { HttpInterceptorFn } from '@angular/common/http';
import { safeGetItem } from './services/safe-storage';

/**
 * Auth interceptor — attaches Bearer token to outgoing API requests
 * and handles CSRF tokens.
 *
 * Satisfies: V-CLIENT-001 (HTTP interceptor for auth tokens).
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = safeGetItem('session', 'auth_token');

  let headers = req.headers;

  // Attach Bearer token if available
  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  // Attach CSRF token for state-changing requests
  if (!['GET', 'HEAD', 'OPTIONS'].includes(req.method)) {
    const csrfToken = getCookie('csrfToken');
    if (csrfToken) {
      headers = headers.set('X-CSRF-Token', csrfToken);
    }
  }

  return next(req.clone({ headers }));
};

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}
